var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle-outline",
    cx: 128,
    cy: 128,
    r: 125
  })), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M92.9,83c0,6.905 -5.55,12.5 -12.4,12.5c-6.85,0 -12.4,-5.595 -12.4,-12.5c0,-6.9 5.55,-12.5 12.4,-12.5c6.85,0 12.4,5.6 12.4,12.5Zm0.1,22.5l-25,0l0,80l25,0l0,-80Zm39.91,0l-24.84,0l0,80l24.845,0l0,-41.995c0,-23.35 30.145,-25.26 30.145,0l0,41.995l24.94,0l0,-50.655c0,-39.4 -44.61,-37.965 -55.09,-18.57l0,-10.775Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3cfd936bc8da8089cb927a456d78abb4.svg";
export { ForwardRef as ReactComponent };